export default __webpack_public_path__ + "static/offer-terms-06982a503d34e791ecf7036c047f66b4.pdf";